export default __webpack_public_path__ + "static/media/background-decoration_dark-light-waves.24cf4bb8.svg";